import { Flex, Heading } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import React, { FC } from 'react'
import { useFindLocaleText } from '../../text-localisation'
import { capitaliseFirstCharacter } from '../../utils'

const StyledHeader = styled(Flex)`
  flex-flow: column wrap;
  align-items: flex-start;
  line-height: 0.2;
`

type Props = {
  originalSearchTerm: string
  correctedSearchTerm?: string
}

export const ZeroResultsHeader: FC<Props> = ({
  originalSearchTerm,
  correctedSearchTerm,
}) => {
  const localiseText = useFindLocaleText()

  const getText = () => {
    if (correctedSearchTerm) {
      return (
        <>
          {localiseText('find.no_results_found_for')}
          <strong>“{capitaliseFirstCharacter(originalSearchTerm)}”</strong>.{' '}
          {localiseText('find.we_have_updated_your_search_to')}
          <strong>“{capitaliseFirstCharacter(correctedSearchTerm)}”</strong>.
        </>
      )
    }

    return (
      <>
        {localiseText('find.no_results')}
        <strong>“{capitaliseFirstCharacter(originalSearchTerm)}”</strong>.
      </>
    )
  }

  return (
    <StyledHeader>
      <Heading
        level="h4"
        typography="typeBodyText"
        data-testid="zero-results-text"
      >
        {getText()}
      </Heading>
    </StyledHeader>
  )
}
